import { base } from '../base';

export const baseODATA = 'gateway/mainodata';

export const whatsAppCampaign = `${base}/whatsAppCampaign`;
export const getWhatsappCampaignODATA = `${baseODATA}/whatsappcampaignsearchquery`;
